import StyledTextField from "./index";

const AuthTextField = ({ notRequired = false, ...props }) => {
  return <StyledTextField variant="filled" required={!notRequired} fullWidth {...props} />;
};

export default AuthTextField;